import styled from 'styled-components'
import { get } from '@ally/metronome-ui'

export const DetailsCardWrapper = styled('div')`
  background: ${get.colors('white')};
  border: thin solid ${get.colors('slate-8')};
  position: relative;
  color: ${get.colors('slate-5')};
`
